import ApiService from '@/services/ApiService';

class EventTypesService {
  static async getEventTypes() {
    const composedURL = `/api3/schedule/event_types/`;
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async getEventType(id) {
    const composedURL = `/api3/schedule/event_types/${id}/`;
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async createEventType(data) {
    const composedURL = `/api3/schedule/event_types/`;
    const response = await ApiService.post(composedURL, data);
    return response;
  }

  static async updateEventType(id, data) {
    const composedURL = `/api3/schedule/event_types/${id}/`;
    const response = await ApiService.put(composedURL, data);
    return response;
  }

  static async deleteEventType(id) {
    const composedURL = `/api3/schedule/event_types/${id}/`;
    return ApiService.delete(composedURL);
  }

  static async deleteEventTypes(ids) {
    const eventTypeIds = ids.join(',');
    const composedURL = `/api3/schedule/event_types/?event_type_ids=${eventTypeIds}`;
    return ApiService.delete(composedURL);
  }
}

export default EventTypesService;
